export const PERMISSION_GRID_EXPORT = 55;

export const FILTER_FILTERSTATUSES = 'filterStatuses';
export const FILTER_AUDIENCES = 'audiences';
export const FILTER_PARTNERS = 'partners';
export const FILTER_DATA_TYPES = 'dataTypes';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_ACCOUNTS = 'accounts';
export const FILTER_CREATED_BY = 'createdBy';
export const FILTER_OWNERS = 'owners';

export const FILTERS_DEPENDENCIES = {
  [FILTER_ACCOUNTS]: [FILTER_PARTNERS],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_FILTERSTATUS = 'filterStatus';
export const COLUMN_PARENT_AUDIENCE = 'parentAudience';
export const COLUMN_PARTNER = 'partner';
export const COLUMN_PARTNER_API_ID = 'partnerApiId';
export const COLUMN_DATA_TYPE = 'dataType';
export const COLUMN_SIZE = 'size';
export const COLUMN_LAST_SYNC = 'lastSyncDate';
export const COLUMN_ACCOUNT = 'account';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_OWNER = 'owner';
export const COLUMN_LAST_SYNC_FAIL_DATE = 'lastSyncFailDate';
export const COLUMN_LAST_FAILS_COUNT = 'syncFailsCount';

export const ACTION_ARCHIVE = 'archive';
export const ACTION_RESTORE = 'restore';
export const ACTION_DELETE = 'delete';
export const ACTION_EDIT = 'edit';
export const ACTION_SYNC = 'sync';
export const ACTION_CHANGE_NAME = 'rename';
export const ACTION_SHARE = 'share';
export const ACTION_ADD_LOOKALIKE_AUDIENCES = 'add_lookalike_audiences';
